import { ListItem } from "./item";

export async function fetchList(id: number): Promise<ListItem[]> {
  try {
    const response = await fetch(`/api/category/${id}`);
    if (!response.ok) {
      throw new Error("Failed to fetch category items");
    }
    const data = await response.json();
    if (!Array.isArray(data)) {
      throw new Error("Expected an array of items");
    }
    return data;
  } catch (error) {
    console.error("Error fetching category items:", error);
    return [];
  }
}
